const routes = [
    {
        path: "/relative/grades",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "relativegrade_index"
        }
    }
];

export default routes;
